import React from 'react';
import './CommonStrip.scss';
import PropTypes from 'prop-types';

const CommonStripWithButton = (props = {}) => {
    const { StripIcon, StripInformation, handleAction, buttonLabel } = props;

    const [start, end] = StripInformation.split('{button}');

    return (
        <div className="strip_background_channel">
            <p>
                <i>{StripIcon} </i>
                <span>
                    {start}
                    <button className="strip_background_channel-button" onClick={handleAction}>
                        {buttonLabel}
                    </button>
                    {end}
                </span>
            </p>
        </div>
    );
};
CommonStripWithButton.propTypes = {
    StripIcon: PropTypes.node,
    StripInformation: PropTypes.string,
    handleAction: PropTypes.func,
    buttonLabel: PropTypes.string,
};
export default React.memo(CommonStripWithButton);
